/**
 * @module apiList - لیسیت تمامی سرویس هایی که از سرور صدا زده می شود
 */

export const LOGIN = 'user/operator_login';
export const AUTH_LOGOUT = 'auth/user_logout';
export const AUTH_TOKEN_USER = 'auth/auth_token_user';
export const OPERATOR_PROFILE = 'user/operator_profile';
export const FORGOT_PASSWORD = 'user/operator_forgot_password';
export const OPERATOR_UPDATE_ONLINE = 'user/operator_update_online';
export const OPERATOR_UPDATE_PASSWORD = 'user/operator_update_password';

/////////////////////////////////////////////////////////////

export const SUPPORT_REQUEST = 'support/support_request';
export const SUPPORT_NUMBER = 'setting/get_support_number';
export const APPLICATION_CONFIG = 'setting/application_config';
export const REASON_SUPPORT_LIST = 'info/reason_support_list';

/////////////////////////////////////////////////////////////

export const FUEL_REQUEST_LOCAL = 'fuel_request/fuel_request_local';
export const OPERATOR_FUEL_REQUEST_HISTORY_LOCAL =
  'fuel_request/operator_fuel_request_local_history';

/////////////////////////////////////////////////////////////

export const OPERATOR_REFUELING = 'fuel_request/operator_refueling';
export const OPERATOR_REQUEST_DETAILS = 'fuel_request/request_details';
export const FUEL_REQUEST_STATUS = 'fuel_request/status_fuel_request';
export const OPERATOR_COMPLETE_REQUEST = 'fuel_request/operator_complete_request';
export const VOLUME_RECEIVED_CONFIRMATION = 'fuel_request/volume_received_confirmation';
export const OPERATOR_FUEL_REQUEST_HISTORY =
  'fuel_request/operator_fuel_request_online_history';
export const VIEW_FUEL_REQUEST_ONLINE_BY_OPERATOR =
  'fuel_request/view_fuel_request_online_by_operator';
export const OPERATOR_REQUEST_INPROCESS_LIST =
  'fuel_request/operator_fuel_request_online_inprocess_list';

/////////////////////////////////////////////////////////////

export const COMPLETE_REQUEST_ORGANIZATION = 'fuel_request/complete_request_organization';
export const OPERATOR_FUEL_REQUEST_ORGANIZATION_HISTORY =
  'fuel_request/operator_fuel_request_organization_history';
export const FUEL_REQUEST_ORGANIZATION_BY_REQUEST_CODE =
  'fuel_request/fuel_request_organization_by_request_code';
export const FUEL_REQUEST_ORGANIZATION_VOLUME_RECEIVED =
  'fuel_request/fuel_request_organization_volume_received';
export const OPERATOR_FUEL_REQUEST_ORGANIZATION_INPROCESS =
  'fuel_request/operator_fuel_request_organization_inprocess_list';

/////////////////////////////////////////////////////////////

export const TANKER_REPAIR_ADD = 'tanker_approval/tanker_repair_add';
export const TANKER_REPAIR_LIST = 'tanker_approval/tanker_repair_by_operator';

/////////////////////////////////////////////////////////////

export const PETROL_STATION = 'petrol_station/petrol_station_list';
export const REFUELING_TANKER_ADD = 'petrol_station/petrol_station_refuel_tanker_add';
export const REFUELING_TANKER = 'petrol_station/petrol_station_refuel_tanker_by_operator';
export const REFUELING_TANKER_UPDATE = 'petrol_station/petrol_station_refuel_tanker_change_volume';
export const FUEL_CAR_PROBE = 'petrol_station/tanker_probe_by_fuel_car';

/////////////////////////////////////////////////////////////

export const APP_VERSION = 'setting/app_version';
